import { PriceType } from 'data/types'
import isNil from 'lodash/isNil'
import last from 'lodash/last'

import { PriceActionType } from './actions'
import * as AT from './actionTypes'

export type PriceStateType = {
  all: PriceType[]
  currentRange?: string
  liveCallback?: (update: PriceType) => void
}

const initialState = {
  all: []
}

const price = (state: PriceStateType = initialState, action: PriceActionType): PriceStateType => {
  switch (action.type) {
    case AT.RESET: {
      return initialState
    }

    case AT.SET: {
      const all = action.payload.prices

      return {
        ...state,
        all
      }
    }

    case AT.SET_RANGE: {
      return {
        ...state,
        currentRange: action.payload.range
      }
    }

    case AT.SET_LIVE_CALLBACK: {
      return {
        ...state,
        liveCallback: action.payload.liveCallback
      }
    }

    case AT.UPDATE: {
      const { price } = action.payload
      const lp = last(state.all)
      let all
      if (!isNil(lp) && price.time === lp.time) {
        all = [price, ...state.all]
      } else {
        all = [...state.all.slice(1), price]
      }

      return {
        ...state,
        all
      }
    }

    case AT.TOGGLE_EXPANDED: {
      return {
        ...state
      }
    }

    default:
      return state
  }
}

export default price
